// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import 'polyfills';

import ReactOnRails from 'react-on-rails';

import CrossingLocale from "../components/Widgets/CrossingLocale/CrossingLocale";

// This is how react_on_rails can see the react_component('ComponentName') in the browser.
// Use :: in place of / and capitalize folder/component names
ReactOnRails.register({
  'CrossingLocale::Crossinglocale': CrossingLocale
});
